import "../LibraryBoxBattle.scss";
import "./BattlesList.scss";
import Control from "../../../1. Core/Control";
import NP, {EventArgs, IHash, ValueChangedEventArgs} from "../../../1. Core/NP";
import TopAppBar from "../../../1. Core/Controls/TopAppBar/TopAppBar";
import Delegate from "../../../1. Core/Delegate";
import {ServerAPI} from "../../../1. Core/ServerAPI";
import DataTable from "../../../1. Core/Controls/DataTable/DataTable";
import BattlesFilterPanel from "../Panels/BattlesFilterPanel";
import Button from "../../../1. Core/Controls/Button/Button";
import IconToggleButton from "../../../1. Core/Controls/IconToggleButton/IconToggleButton";
import Menu from "../../../1. Core/Controls/Menu/Menu";
import BattleStatisticsDialog from "../../../9. DataInput/BattleStatisticsDialog";
import {
    downloadVideoFile,
    getInternalWidgets,
    getWeightStringById,
    IWidget,
    moveItemInArray,
    titleCaseWord
} from "../../Util";
import CreateBoutDialog from "../Dialogs/CreateBoutDialog";
import TechReport from "../../Analytics/TechReport";
import EditBoutDialog from "../Dialogs/EditBoutDialog";

import MMAStatDialog from "../../../9. DataInput/MMAStatDialog";
import BoxJudgePointsInputDialog from "../../../6. Judge/BoxJudgePointsInputDialog";
import BoxDashboard from "../../Analytics/BoxDashboard";
import EditBoutStatisticsDialog from "../Dialogs/EditBoutStatisticsDialog";
import {getSportType, IBattle, PageMode, SportType} from "../../types";
import ListItem, {IItem} from "../../../1. Core/Controls/ListBox/ListItem";
import {JudgeInputBoutDialog} from "../../../6. Judge/JudgeInputBoutDialog";
import {HightlightInputBoutDialog} from "../../../9. DataInput/HightlightInputBoutDialog";
import BattleVideoGeneratorDialog from "../../../3. VideoEditor/BattleVideoGeneratorDialog";
import ImportBattleDataDialog from "../Dialogs/ImportBattleDataDialog";
import {getCurrentUser} from "../../../1. Core/UserInfo";
import {createWidgetDialog} from "./CreateWidgetDialog";
import BeforeBattleVideoGeneratorDialog from "../../../3. VideoEditor/BeforeBattleVideoGeneratorDialog";


let moment = require('moment');


interface IBattleListItem {
    Battle: IBattle,
    RedName: string,
    BlueName: string,
    Stage: string,
    Weight: string,
    highlightIndex: number
    Result: string
}

interface IBattleFiltersSort {
    FilterText?: string,
    Sex: number,
    WeightCategory: number,
    TournamentId: string,
    SortDirection: number,
    SortField: string;
    JudgeId?: number;
    EventId: number
}

export default class BattlesList extends Control {
    private _OpenedItemId: number;
    private _Count: number;
    private _Offset: number;
    private _topAppBar: TopAppBar;
    private _FilterText: string;
    private EvShowPageModeClick: Delegate;
    private EvPageModeChanged: Delegate;
    private _Battles: IBattleListItem[];
    private _dataTable: DataTable;
    private _filtersPanel: BattlesFilterPanel;

    private _techReport: TechReport;
    private _dataWithFiltersNode: HTMLElement;
    //private _dashBox: DashboardBox;
    private _battleInfoView: BoxDashboard;
    private _dashNode: HTMLElement;
    //private _mainDashBtn: Button;
    private _openBattleInfoBtn: Button;
    private _videoBtn: Button;
    private _referBtn: Button;
    private _currentBattle: IBattle;
    private _videoContainer: HTMLElement;
    private _DrillDownFilter: IBattleFiltersSort;
    private _StartDash: string;

    private _btnNode: HTMLElement;
    private _AllCount: number;
    private _topVideoAppBar: TopAppBar;

    private _Mode: PageMode;
    private _timeId: any;

    constructor(settings: object) {
        super(settings);
        this._render();
    }

    _initFields(settings: object) {
        this._DrillDownFilter = null;
        this._StartDash = 'Overview';  //Refereeing
        this.EvShowPageModeClick = new Delegate();
        this.EvPageModeChanged = new Delegate();
        this._OpenedItemId = null;
        this._FilterText = '';
        this._Mode = PageMode.mmaresults;
        super._initFields(settings);
    }

    _render() {
        this.np_render();
        this.addClass('battle-list');
        this._Count = 100;
        this._Offset = 0;


        this._topAppBar = new TopAppBar({
            Class: 'top-app-bar--no-shadow top-app-bar--light library-box-list__app-bar',
            Caption: NP.RM.getString('Bouts'),
            ParentNode: this._root,
            EvSearch: (s: Control, e: ValueChangedEventArgs) => {
                this._AllCount = null;
                this._FilterText = e.Value;
                this._Offset = 0;
                this._refreshList();
            },
            EvHideSearch: () => {
                this._AllCount = null;
                this._Offset = 0;
                this._FilterText = null;
                this._refreshList();
            },
            ShowSearchButton: this._DrillDownFilter == null,
            MainButton: {
                FontImage: NP.FontImages.menu,
                EvClick: () => this.EvShowPageModeClick.fire(this)
            },
            CustomMainButton: this._DrillDownFilter
                ? new Button({
                    Class: 'top-app-bar__title breadcrumb-root',
                    Content: NP.RM.getString(this._DrillDownFilter.EventId ? 'Events' : 'Refereeing'),
                    EvClick: () => this.EvPageModeChanged.fire(this)
                })
                : null,
            EvFocusSearch: () => {
            }
        });

        if (!this._DrillDownFilter) {
            if (NP.isAdmin())
                this._topAppBar.addItem(new IconToggleButton({
                    FontImage: NP.FontImages.add,
                    Value: 'CreateBout',
                    EvClick: () => (new CreateBoutDialog({
                        SportType: getSportType(this._Mode),
                        EvOkButtonClick: () => {
                            this._AllCount = null;
                            this._Offset = 0;
                            this._refreshList();
                        },
                        IsNew: true
                    })).refresh().show()
                }));

            // this._topAppBar.addItem(new FileUploadIcon({
            // 	ParentNode: this._dashNode,
            // 	FontImage: NP.FontImages.upload,
            // 	Accept: '.csv',
            // 	Class: 'app-button--outlined',
            // 	IsVisible: NP.isAdmin(),
            // 	EvFileChanged: (s: object, e: { Result: string }) =>
            // 	{
            // 		ServerAPI.call("SportService.importBattles", [e.Result]).then(() =>
            // 		{
            // 			NP.showMessage({RK: 'Done'});
            // 			this.refresh();
            // 		});
            // 		this._topAppBar.getRightItems()[1].setValue(null);
            // 	}
            // }));

            this._topAppBar.addItem(new IconToggleButton({
                FontImage: NP.FontImages.tune,
                Value: 'Filters',
                EvClick: (btn: IconToggleButton) => {
                    btn.setData(!btn.getData())
                    this._filtersPanel.setIsVisible(!this._filtersPanel.getIsVisible());
                    this.setWidth(this._Width);
                }
            }));
        }

        this._dataWithFiltersNode = NP.createNode(this._root, 'data-with-filters-container');

        let columns = [{
            Content: NP.RM.getString('Red'),
            Width: '20%',
            PropertyContent: 'ViewRedName'
        }, {
            Content: NP.RM.getString('Blue'),
            Width: '20%',
            PropertyContent: 'ViewBlueName'
        }, {
            Content: NP.RM.getString('Stage'),
            PropertyContent: 'Stage',
            Width: '15%'
        }, {
            Content: NP.RM.getString('WeightCategory'),
            PropertyContent: 'Weight',
            Width: '20%'
        }, {
            Content: NP.RM.getString('Date'),
            PropertyContent: 'Date',
            Width: '15%'
        }, {
            Content: NP.RM.getString('Result'),
            PropertyContent: 'Result',
            Width: '10%'
        }];

        if (this._DrillDownFilter && !this._DrillDownFilter.EventId) {
            columns.splice(2, 0, {
                Content: NP.RM.getString('Tournament'),
                PropertyContent: 'Tournament',
                Width: ''
            });
            columns.push({
                Content: NP.RM.getString('Points'),
                PropertyContent: 'Points',
                Width: ''
            });
            columns.forEach(c => c.Width = '12.5%');

            columns[0].Width = columns[1].Width = columns[2].Width = '15%';
            columns[columns.length - 1].Width = '8%';
        }


        this._dataTable = new DataTable({
            ParentNode: this._dataWithFiltersNode,
            Class: 'app-list--avatars mdc-data-table--margin data-table-battle',
            MultiSelect: false,
            CanDragRows: this._DrillDownFilter?.EventId && (this._Mode == PageMode.mmaevents || this._Mode == PageMode.kbbouts),
            EnableSort: !this._DrillDownFilter?.EventId,
            ShowRowIndex: true,
            ImageWidth: 32,
            Columns: columns,
            ShowPaginator: true,
            ShowSettingsButton: this._Mode != PageMode.mmahighlights,
            HeaderPaddingRight: this._Mode == PageMode.mmahighlights ? '70px' : '',
            CustomSettingsHeader: this._Mode == PageMode.mmahighlights ? '&nbsp; Full &nbsp; &nbsp; Optimal &nbsp;&nbsp; Short' : '',
            CustomSettingsButtonCreated: (ctrl: IconToggleButton, index: number) => {
                let b = (ctrl.getData() as { Battle: IBattle }).Battle;
                switch (index) {
                    case 0:
                        if (!b.HLUrl_Full)
                            ctrl.setEnabled(false)
                        break;
                    case 1:
                        if (!b.HLUrl_Optimal)
                            ctrl.setEnabled(false)
                        break;
                    case 2:
                        if (!b.HLUrl_Short)
                            ctrl.setEnabled(false)
                        break;
                }
            },
            CustomSettingsButton: this._Mode == PageMode.mmahighlights ? [{
                FontImage: NP.FontImages.download,
                ToolTip: 'Full',
                EvClick: (s: Control, e: EventArgs) => {
                    e.Event.preventDefault()
                    e.Event.stopPropagation();
                    let row = s.getData() as { Battle: IBattle };
                    if (row.Battle)
                        downloadVideoFile(row.Battle.HLUrl_Full, row.Battle.Name, "full")
                }
            }, {
                FontImage: NP.FontImages.download,
                ToolTip: 'Optimal',
                EvClick: (s: Control, e: EventArgs) => {
                    e.Event.preventDefault()
                    e.Event.stopPropagation();
                    let row = s.getData() as { Battle: IBattle };
                    if (row.Battle)
                        downloadVideoFile(row.Battle.HLUrl_Optimal, row.Battle.Name, "optimal")
                }
            }, {
                FontImage: NP.FontImages.download,
                ToolTip: 'Short',
                EvClick: (s: Control, e: EventArgs) => {
                    e.Event.preventDefault()
                    e.Event.stopPropagation();
                    let row = s.getData() as { Battle: IBattle };
                    if (row.Battle)
                        downloadVideoFile(row.Battle.HLUrl_Short, row.Battle.Name, "short")
                }
            }] : null,
            EvSortClick: (s: DataTable, e: any) => {
                e.CanceSort = true;
                this._Offset = 0;
                switch (e.Column) {
                    case 0:
                        this._filtersPanel.setSortValues('Red', e.Direction);
                        this._refreshList();
                        break;
                    case 1:
                        this._filtersPanel.setSortValues('Blue', e.Direction);
                        this._refreshList();
                        break;
                    case 2:
                        this._filtersPanel.setSortValues('Stage', e.Direction);
                        this._refreshList();
                        break;
                    case 3:
                        this._filtersPanel.setSortValues('Weight', e.Direction);
                        this._refreshList();
                        break;
                    case 4:
                        this._filtersPanel.setSortValues('Date', e.Direction);
                        this._refreshList();
                        break;
                    case 5:
                        this._filtersPanel.setSortValues('Result', e.Direction);
                        this._refreshList();
                        break;
                    case 6:
                        this._DrillDownFilter.SortField = 'Rating';
                        if (!this._DrillDownFilter.SortDirection)
                            this._DrillDownFilter.SortDirection = 1;
                        else
                            this._DrillDownFilter.SortDirection = -this._DrillDownFilter.SortDirection;
                        this._refreshList();
                        break;
                }
                NP.localStorage['BattleSortState2'] = JSON.stringify(this._filtersPanel.getSortValues())
            },
            EvPaginatorLeftClick: () => {
                this._Offset -= this._Count;
                this._refreshList();
            },
            EvItemClick: (s: object, e: { Item: IBattleListItem }) => {
                this.showDash(e.Item.Battle);
            },
            EvPaginatorRightClick: () => {
                this._Offset += this._Count;
                this._refreshList();
            },
            EvItemContextMenu: async (s: any, e: { Event: any, Item: IBattleListItem }) => {
                if (this._Mode == PageMode.mmahighlights)
                    return;

                if (this._Mode == PageMode.bookmaker) {
                    this.showBookmakerContextMenu(e)
                    return;
                }

                let items = await this.getMenuItems(e.Item.Battle);
                if (items && items.length > 0) {
                    let menu = new Menu({
                        Items: items,
                        EvItemSelected: (s: Menu, event: { Item: ListItem }) => {
                            switch (event.Item.getValue()) {
                                case 'Edit':
                                    (new EditBoutDialog({
                                        Battle: e.Item.Battle,
                                        EvOkButtonClick: () => this._refreshList()
                                    })).show();
                                    break;
                                case 'Import':
                                    (new ImportBattleDataDialog({
                                        Battle: e.Item.Battle,
                                        EvOkButtonClick: () => this._refreshList()
                                    })).show();
                                    break;
                                case 'EditBattleStatistics':
                                    (new EditBoutStatisticsDialog({
                                            Battle: e.Item.Battle,
                                            EvClosed: () => this.refresh()
                                        })
                                    ).show();
                                    break;
                                case 'Delete':
                                    this.deleteBattle(e.Item.Battle);
                                    break;
                                case 'BattleStatistics':
                                    if (e.Item.Battle.Type == SportType.MMA)
                                        (new MMAStatDialog({Battle: e.Item.Battle})).show();
                                    else
                                        (new BattleStatisticsDialog({BattleId: e.Item.Battle.Id, ...e.Item.Battle})).show();
                                    break;
                                case 'BattleStatisticsGamePadMMA':
                                    window.open(`/gamepadMMA/${e.Item.Battle.Id}`, 'GamePad', "top=0 left=0 width=250 height=600 menubar=no");
                                    break;
                                case PageMode.gamepadkb:
                                    window.open(`/gamepadkb/${e.Item.Battle.Id}`, 'GamePad', "top=0 left=0 width=250 height=600 menubar=no");
                                    break
                                case 'BattleStatisticsGamePad':
                                    window.open(`/gamepad2/${e.Item.Battle.Id}`, 'GamePad', "top=0 left=0 width=250 height=600 menubar=no");
                                    break;
                                case 'Highlights':
                                    (new HightlightInputBoutDialog({
                                        Battle: e.Item.Battle,
                                        EvClosed: () => this._refreshList()
                                    })).show()
                                    break;
                                case 'JudgePoints':

                                    if (this._Mode == PageMode.mmaresults) {
                                        (new JudgeInputBoutDialog({
                                            Battle: e.Item.Battle
                                        })).show()
                                    } else
                                        (new BoxJudgePointsInputDialog({
                                            Battle: e.Item.Battle
                                        })).show();
                                    break;
                                case 'Video':
                                    (new BattleVideoGeneratorDialog({
                                        Battle: e.Item.Battle
                                    })).show();
                                    break;
                                case 'CreatePrevVideo':
                                    (new BeforeBattleVideoGeneratorDialog({
                                        Battle: e.Item.Battle
                                    })).show();
                                    break;
                                case 'CreateWidget':
                                    createWidgetDialog(e.Item.Battle)
                                    break;
                                default:
                                    let widget: IWidget = event.Item.getData();
                                    if (widget && widget.Page) {
                                        let sep = widget.Page.indexOf('?') > -1 ? '&' : '?';
                                        window.open(`/${widget.Page}${sep}id=${e.Item.Battle.GloryFightID}&lang=${NP.getCurrentCulture().Name}`);
                                    }
                                    break;
                            }
                        }
                    });
                    menu.showContextMenu(e.Event);
                }
            },
            EvSelectionChanged: () => {
            },
            EvScrolled: (s: DataTable, e: any) => this._onScrolled(s, e),
            EvRowMoved: (o: object, args: { Row: any, Index: number }) => {
                this.move(args.Row.Battle.Id, args.Index)
            }
        });

        this._filtersPanel = new BattlesFilterPanel({
            ParentNode: this._dataWithFiltersNode,
            Width: 280,
            TType: getSportType(this._Mode),
            EvFilterSortChanged: () => {
                this._AllCount = null;
                this._Offset = 0;
                this._refreshList();
            }
        });

        if (NP.localStorage['BattleSortState3']) {
            try {
                let state = JSON.parse(NP.localStorage['BattleSortState3'])
                this._filtersPanel.setSortValues(state.SortField, state.SortDirection);
            } catch (ignore) {

            }
        }
    }

    async move(id: number, newIndex: number) {
        let movingItem = this._Battles.find(b => b.Battle.Id == id);
        let movingIndex = this._Battles.findIndex(b => b == movingItem);

        moveItemInArray(this._Battles, movingIndex, newIndex);


        await ServerAPI.post('/battle/change-order', this._Battles.map(b => b.Battle))


        //this._dataTable.setRows(this._Battles);
        this._refreshList();
    }

    showBookmakerContextMenu(e: { Event: any, Item: IBattleListItem }) {
        let menu = new Menu({
            Items: [{
                RK: 'Compare',
                Value: 'mma-compare.html'
            }, {
                Content: 'Stat table',
                Value: 'mma-stat-table.html'
            }],
            EvItemSelected: (s: Menu, args: { Item: ListItem }) => {
                let battle = e.Item.Battle
                switch (args.Item.getValue()) {
                    case 'mma-compare.html':
                        window.open(`/mma-compare.html?red=${battle.RedGloryFighterID}&blue=${battle.BlueGloryFighterID}&lang=${NP.getCurrentCulture().Name}`);
                        break;
                    case 'mma-stat-table.html':
                        window.open(`/mma-stat-table.html?id=${battle.GloryFightID}&lang=${NP.getCurrentCulture().Name}`);
                        break;
                }
            }
        });
        menu.showContextMenu(e.Event);
    }


    async getMenuItems(battle: IBattle) {
        let widgets = await getInternalWidgets();
        let items = [] as IItem[];
        let isMMA = battle.Type == SportType.MMA || battle.Type == SportType.KB;

        let gamepadItems = [{
            FontImage: NP.FontImages.database,
            Content: 'GamePad',
            Value: 'BattleStatisticsGamePadMMA'
        }]

        if (battle.Type == SportType.KB) {
            gamepadItems.push({
                FontImage: NP.FontImages.database,
                Content: 'GamePad KB',
                Value: PageMode.gamepadkb
            })
        } else if (battle.Type == SportType.Box) {
            gamepadItems = [{
                FontImage: NP.FontImages.database,
                Content: 'BattleStatisticsGamePad',
                Value: 'BattleStatisticsGamePad'
            }]
        }


        if (NP.isAdmin()) {
            items.push({
                    FontImage: NP.FontImages.edit,
                    RK: 'Edit',
                    Value: 'Edit'
                }, {
                    FontImage: NP.FontImages.edit,
                    RK: 'EditBattleStatistics',
                    Value: 'EditBattleStatistics'
                }, {IsSeparator: true}, battle.Type == SportType.Box && {
                FontImage: NP.FontImages.database,
                RK: 'BattleStatistics',
                Value: 'BattleStatistics'
            }, ...gamepadItems,
                {
                    FontImage: NP.FontImages.database,
                    RK: 'JudgePoints',
                    Value: 'JudgePoints'
                }, isMMA &&
            {
                FontImage: NP.FontImages.database,
                Content: 'Highlights',
                Value: 'Highlights'
            }, isMMA && battle.VideoUrl && {
                FontImage: NP.FontImages.play_arrow,
                Content: 'Video',
                Value: 'Video'
            }, isMMA && battle.Status == 'Not started' && {
                FontImage: NP.FontImages.play_arrow,
                Content: 'Create Prev Video',
                Value: 'CreatePrevVideo'
            }, {
                    FontImage: NP.FontImages.add,
                    Content: 'Create widget',
                    Value: 'CreateWidget'
                }
            );
        } else if (NP.getCurrentUser().isJudge())
            items.push({
                FontImage: NP.FontImages.database,
                RK: 'JudgePoints',
                Value: 'JudgePoints'
            });


        if (widgets && widgets.length > 0) {
            let widgetItems = widgets
                .filter(x => battle.Type === x.BattleType && x.Type === "Battle")
                .map(x => ({
                    FontImage: NP.FontImages.link,
                    Content: `${x.Name} (${x.Page})`,
                    Value: x.Key,
                    Data: x
                }));

            if (items.length)
                items.push({IsSeparator: true});

            items.push(...widgetItems);
        }

        if (NP.isAdmin()) {
            items.push({
                IsSeparator: true
            }, {
                FontImage: NP.FontImages.delete,
                RK: 'Delete',
                Value: 'Delete'
            });
        }

        return items;
    }

    showDash(battle?: IBattle) {
        if (!battle)
            return;

        if (battle.Type == SportType.MMA || battle.Type == SportType.KB) {
            if (getCurrentUser().getIsAdmin()) {

                if (this._Mode == PageMode.mmahighlights)
                    (new BattleVideoGeneratorDialog({
                        Battle: battle
                    })).show();
                else {
                    // (new BattleDialog({
                    // 	Battle: battle
                    // })).show();
                }
            }
            return;
        }

        if (this._dataWithFiltersNode.parentNode)
            this._root.removeChild(this._dataWithFiltersNode);
        if (battle) {
            this._currentBattle = battle;
            NP.updateBrowserUrlString(true, this._Mode, battle.Id);
        }

        if (!this._dashNode) {
            this._dashNode = NP.createNode(this._root, 'battle-list__dash-node');

            this._btnNode = NP.createNode(this._dashNode, 'battle-list__dash-node__btn-node');

            // this._mainDashBtn = new Button({
            // 	RK: 'Overview',
            // 	ParentNode: this._btnNode,
            // 	Class: 'app-button--outlined',
            // 	EvClick: () => this.openOverviewDash()
            // });

            this._openBattleInfoBtn = new Button({
                RK: 'Overview',
                ParentNode: this._btnNode,
                Class: 'app-button--outlined',
                EvClick: () => {
                    this.openBattleInfo();
                }
            });

            this._referBtn = new Button({
                RK: 'Judge report',
                ParentNode: this._btnNode,
                Class: 'app-button--outlined',
                EvClick: () => this.openTechDash()
            });

            this._videoBtn = new Button({
                RK: 'VideoOfBattle',
                ParentNode: this._btnNode,
                Class: 'app-button--outlined',
                EvClick: () => this.openVideo()
            });
        } else
            this._root.appendChild(this._dashNode);


        if (this._videoBtn)
            this._videoBtn.setIsVisible(!!this._currentBattle.VideoUrl);

        this._topAppBar.removeClass('top-app-bar--no-shadow');

        this._referBtn.setIsVisible(this._currentBattle.Id > -1);    //-1 это проф турнир, для него пока скрываем судейский отчёт

        if (this._StartDash == 'Refereeing')
            this.openTechDash();
        else
            //this.openOverviewDash();
            this.openBattleInfo();

    }

    deleteBattle(battle: IBattle) {
        NP.showConfirm({
            Content: NP.RM.getString('DeleteBattleConf').replace("{0}", battle.RedName).replace("{1}", battle.BlueName),
            EvOkButtonClick: () => {
                ServerAPI.callUiApi(`/battle/${battle.Id}`, null, 'DELETE').then(() => {
                    this._Offset = 0;
                    this._refreshList();
                });
            }
        });
    }

    selectBtn(btn: Button) {
        //this._mainDashBtn.removeClass('app-button--selected');
        this._openBattleInfoBtn.removeClass('app-button--selected');
        this._referBtn.removeClass('app-button--selected');
        if (this._videoBtn)
            this._videoBtn.removeClass('app-button--selected');

        btn.addClass('app-button--selected');
    }

    getBattleName() {
        return this._currentBattle.Name.replace(" -", " (Red) -") + " (Blue)";
    }

    reOpenCurrentDash() {
        if (this._currentBattle && this._currentBattle.Type == 'MMA')
            return;
        if (this._battleInfoView.getIsVisible())
            this.openBattleInfo();
        else if (this._techReport.getIsVisible())
            this.openTechDash();
    }

    openTechDash() {
        //this._dashBox.hide();
        if (this._battleInfoView)
            this._battleInfoView.hide();
        this.selectBtn(this._referBtn);

        if (!this._techReport)
            this._techReport = new TechReport({
                Width: this._Width,
                ParentNode: this._dashNode,
                Height: this._getContentHeight() - 64,
                EvClosed: () => this.closeDash()
            });
        else
            this._techReport.show();

        this._techReport.setCaption(this.getBattleName());
        this._techReport.refresh(this._currentBattle);


        this.hideVideo();
    }

    openBattleInfo() {
        if (this._currentBattle && this._currentBattle.Type == 'MMA')
            return;
        this.selectBtn(this._openBattleInfoBtn);
        if (!this._battleInfoView) {
            this._battleInfoView = new BoxDashboard({
                Class: "battle-list__battle-info-view",
                Battle: this._currentBattle,
                ParentNode: this._dashNode,
                EvClosed: () => this.closeDash()
            });
        } else {
            this._battleInfoView.show();
            this._battleInfoView.setBattle(this._currentBattle);
            this._battleInfoView.refreshData();
        }

        //this._battleInfoView.setCaption(this.getBattleName());

        //this._dashBox.hide();
        if (this._techReport)
            this._techReport.hide();
        this.hideVideo();
    }

    hideVideo() {
        if (this._videoContainer) {
            if (this._dashNode.contains(this._videoContainer))
                this._dashNode.removeChild(this._videoContainer);
            this._topVideoAppBar.hide();
        }
    }

    openVideo() {
        let videoUrl = this.getVideoUrl();
        let needOpenInNewWindow = window.location.href.startsWith('https') && videoUrl && !videoUrl.startsWith('https');

        if (needOpenInNewWindow) {
            window.open(videoUrl);
        } else {
            if (this._techReport)
                this._techReport.hide();
            if (this._battleInfoView)
                this._battleInfoView.hide();
            //this._dashBox.hide();
            this.selectBtn(this._videoBtn);
            if (!this._videoContainer) {
                this._topVideoAppBar = new TopAppBar({
                    Class: 'top-app-bar--no-shadow top-app-bar--light top-app-bar--white',
                    Caption: 'test',
                    ParentNode: this._dashNode,
                    MainButton: {
                        FontImage: NP.FontImages.close,
                        EvClick: () => this.closeDash()
                    },
                });
                this._videoContainer = NP.createNode(this._dashNode, 'video-container', 'iframe');

                this._videoContainer.setAttribute('width', '640');
                this._videoContainer.setAttribute('height', '360');
                this._videoContainer.setAttribute('frameborder', '0');
                this._videoContainer.setAttribute('allow', 'autoplay; fullscreen');
                this._videoContainer.setAttribute('allowfullscreen', 'true');
            } else {
                this._topVideoAppBar.show();
                this._dashNode.appendChild(this._videoContainer);
            }

            this._topVideoAppBar.setCaption(this.getBattleName());
            this._videoContainer.setAttribute('src', videoUrl);
        }
    }

    getVideoUrl() {
        let url = this._currentBattle.VideoUrl;
        if (url.startsWith("https://www.youtube.com")) {
            let v = NP.getQueryParam("v", url.split("?")[1]);
            return `https://www.youtube.com/embed/${v}`;
        }
        return url;
    }

    closeDash() {
        NP.updateBrowserUrlString(true, this._Mode);
        this._topAppBar.addClass('top-app-bar--no-shadow');
        this._root.removeChild(this._dashNode);
        this._root.appendChild(this._dataWithFiltersNode);
    }

    _onScrolled(s: DataTable, e: any) {
        if (e.scroll > 0 && e.isSmall)
            this._topAppBar.addClass('top-app-bar--fixed-scrolled');
        else
            this._topAppBar.removeClass('top-app-bar--fixed-scrolled');
    }

    refresh() {
        if (this._DrillDownFilter) {
            this._filtersPanel.setIsVisible(false);
        } else {
            this._filtersPanel.loadFilters();
        }
        this._refreshList().then(() => {
            if (this._OpenedItemId != null) {
                let item = this._Battles.find(x => x.Battle.Id === this._OpenedItemId);
                if (item) {
                    this.showDash(item.Battle);
                } else {
                    ServerAPI.callUiApi(`/battle/${this._OpenedItemId}`).then((battle: IBattle) => {
                        this.showDash(battle);
                    });
                }
            }
        });

        this._onScrolled(null, {
            scroll: 0,
            isSmall: this._dataTable.getIsSmall()
        });

        if (this._timeId)
            clearInterval(this._timeId)

        this._timeId = setInterval(() => {
            if (!this._OpenedItemId)
                this.updateBackground()
        }, 3000)
    }

    getCurrentFilter() {
        return this._DrillDownFilter || this._filtersPanel.getFilterData();
    }

    needCalcRaiting(winType: string) {
        switch (winType) {
            case "WP":
            case "UD":
            case "MD":
            case "SD":
                return true;
        }
        return false;
    }

    createRow(el: IBattle) {
        let format = {
            f: "0,0.00",
            m: '{{Value}}'
        };

        let arrViewRedName = el.RedName.split(" ")
        let arrViewBlueName = el.BlueName.split(" ")

        let res = {
            Battle: el,
            RedName: el.RedName,
            BlueName: el.BlueName,
            ViewRedName: titleCaseWord(arrViewRedName[0]) + ' ' + titleCaseWord(arrViewRedName.splice(1, arrViewBlueName.length - 1).join(' ')),
            ViewBlueName: titleCaseWord(arrViewBlueName[0]) + ' ' + titleCaseWord(arrViewBlueName.splice(1, arrViewBlueName.length - 1).join(' ')),
            Stage: el.Stage,
            Tournament: el.Tournament,
            Weight: getWeightStringById(el.WeightId),
            highlightIndex: el.WinnerName ? (el.RedName == el.WinnerName ? 0 : 1) : -1,
            Points: this.needCalcRaiting(el.WinType) && (el.Points || el.Points == 0) ? NP.applyFormat(el.Points, format, 1) : '',
            Date: el.Date ? moment(el.Date).format(NP.getDayFormat()) : "",
            Result: ''
        }

        if (el.Status === 'Canceled')
            res.Result = NP.RM.getString('BattleCancelled');
        else if (el.Status == "NoContest")
            res.Result = NP.RM.getString('NoContest')
        else if (el.Status == "Not started")
            res.Result = NP.RM.getString('NotStarted')
        else if (el.Status == "Finished") {
            if (el.Winner === 0)
                res.Result = NP.RM.getString('Draw');
            else if (el.WinnerName)
                res.Result = el.WinType ? (el.WinType + " " + (el.WinRound || '')) : ""
            else
                res.Result = 'Finished';


            res.Result = `<div style="background: #0b8a3d; padding: 4px; color: #fff; border-radius: 4px">${res.Result}</div>`
        }

        return res;
    }

    _createPaylodBattleItems() {
        let payload = {
            FilterText: this._FilterText,
            Offset: this._Offset,
            Count: this._Count,
            ...this.getCurrentFilter(),
            SportType: this._Mode == PageMode.bookmaker ? null : getSportType(this._Mode)
        };

        if (this._DrillDownFilter) {
            payload.JudgeId = this._DrillDownFilter.JudgeId;
            if (this._DrillDownFilter.EventId)
                payload.SortField = 'Event'
        }

        return payload
    }


    _refreshList(): Promise<any> {
        if (!this.isLive())
            return;
        this._dataTable.setRows([]);

        return ServerAPI.callUiApi("/battle/items", this._createPaylodBattleItems(), 'POST').then((response: {
            List: IBattle[],
            AllCount: number
        }) => {
            if (response) {
                if (!this._AllCount)
                    this._AllCount = response.AllCount;

                this._Battles = response.List.map(el => this.createRow(el));

                this._dataTable.setShowPaginator(this._AllCount > this._Count);

                this._dataTable.getRightPagButton().setEnabled(this._Offset + this._Count < this._AllCount);
                this._dataTable.updatePagCaption(`${this._Offset + 1} - ${Math.min(this._Offset + this._Count, this._AllCount)} ${NP.RM.getString("of")} ${this._AllCount}`);
                this._dataTable.getLeftPagButton().setEnabled(this._Offset > 0);

                this._dataTable.setRows(this._Battles);

                let filter = this.getCurrentFilter();
                if (filter)
                    switch (filter.SortField) {
                        case 'Red':
                            this._dataTable.updateSortIndicator(0, filter.SortDirection);
                            break;
                        case 'Blue':
                            this._dataTable.updateSortIndicator(1, filter.SortDirection);
                            break;
                        case 'Stage':
                            this._dataTable.updateSortIndicator(2, filter.SortDirection);
                            break;
                        case 'Weight':
                            this._dataTable.updateSortIndicator(3, filter.SortDirection);
                            break;
                        case 'Date':
                            this._dataTable.updateSortIndicator(4, filter.SortDirection);
                            break;
                        case 'Result':
                            this._dataTable.updateSortIndicator(5, filter.SortDirection);
                            break;
                    }
            }
        });
    }


    updateBackground() {
        if (!this.isLive()) {
            if (this._timeId)
                clearInterval(this._timeId)
            return;
        }

        ServerAPI.callUiApi("/battle/items", this._createPaylodBattleItems(), 'POST', false, false).then((response: {
            List: IBattle[],
            AllCount: number
        }) => {
            if (!response)
                return

            let newBattles = response.List.map(el => this.createRow(el));

            for (let i = 0; i < this._Battles.length; i++) {
                if (this._Battles[i].Result != newBattles[i].Result) {
                    this._Battles[i] = newBattles[i];
                    this._dataTable.updateRow(newBattles[i] as any);
                }
            }
        });
    }

    getBattles() {
        return this._Battles;
    }

    _getContentHeight() {
        return this._Height - (this._DrillDownFilter ? 0 : this._topAppBar.getOffsetHeight());
    }

    setHeight(value: number) {
        super.setHeight(value);
        let h = this._getContentHeight();
        this._dataTable.setHeight(h);
        this._filtersPanel.setHeight(h);
        //if (this._dashBox)
        //	this._dashBox.setHeight(h - 64);

        if (this._techReport)
            this._techReport.setHeight(h - 64);

        // if (this._battleInfoView) {
        // 	this._battleInfoView.setHeight(value);
        // }
    }

    setWidth(value: number) {
        super.setWidth(value);
        this._dataTable.setWidth(value);
        //if (this._dashBox)
        //	this._dashBox.setWidth(value);

        if (this._techReport)
            this._techReport.setWidth(value);

        if (this._dataTable.getIsSmall()) {
            this._topAppBar.removeClass('top-app-bar--no-shadow');
            this.setHeight(this._Height);
        } else {
            this._topAppBar.addClass('top-app-bar--no-shadow');
            this.setHeight(this._Height);
        }

        // if (this._battleInfoView) {
        // 	this._battleInfoView.setWidth(value);
        // }
    }

    getTopAppBar() {
        return this._topAppBar;
    }

    getDataTable() {
        return this._dataTable;
    }


    destroy() {
        if (this._timeId)
            clearInterval(this._timeId)
        super.destroy()
    }
}
